import { render, staticRenderFns } from "./NewEdit.vue?vue&type=template&id=e20ab55e&scoped=true&"
import script from "./NewEdit.vue?vue&type=script&lang=js&"
export * from "./NewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20ab55e",
  null
  
)

export default component.exports